/**
 * MotifPicker : grille de 6 boutons pour choisir le motif de sortie (À table par défaut).
 * Le motif actif est en accent-100. Réutilisable partout où l'on sort une bouteille.
 */
import { EXIT_MOTIFS } from '../../constants';

export function MotifPicker({ value, onChange, testId = 'motif' }) {
  return (
    <div className="grid grid-cols-3 gap-2" data-testid={testId}>
      {EXIT_MOTIFS.map((m) => (
        <button
          key={m.key}
          data-testid={`${testId}-${m.key}`}
          onClick={() => onChange(m.key)}
          className={`h-11 rounded-md border text-[13px] transition-colors ${
            value === m.key ? 'vd-selected border-gold text-gold800' : 'border-hair hover:bg-surface'
          }`}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
